import Page from 'components/Page';
import Table from 'components/Table';
import React, { useMemo, useState } from 'react';
import { pageColumns } from './columns';
import { useAccessibilityReview } from './context';
import { PageEvidenceModal } from './Evidence';
import { InactiveNotice, PageIntroduction, PageTypeFilter, ReviewPage, TABLE_SCROLL } from './ReviewPage';
import { usePageInventory } from './usePageInventory';
import { inventoryTableRows } from './viewModel';

const Pages = () => {
  const { scope, pageType, result, shellLoading } = useAccessibilityReview();
  const [selectedPage, setSelectedPage] = useState(null);
  const inventory = usePageInventory({ pageType, enabled: Boolean(scope) });
  const pages = useMemo(() => inventoryTableRows(inventory, result), [inventory, result]);
  const pdfScanningEnabled = inventory?.pdfScanningEnabled ?? scope?.pdfScanningEnabled;
  const columns = useMemo(() => pageColumns({
    onView: setSelectedPage,
    pdfScanningEnabled,
    pageType,
    scanHistory: scope?.scanHistory,
  }), [pageType, pdfScanningEnabled, scope?.scanHistory]);

  return (
    <ReviewPage title="Pages & PDFs">
      <Page.Content>
        {!shellLoading && !scope && <InactiveNotice />}
        <PageIntroduction title="Inventoried pages and PDFs">
          Open evidence for an HTML page or PDF, including documents with no findings.
        </PageIntroduction>
        <PageTypeFilter counts={inventory && {
          total: inventory.totalCount,
          html: inventory.htmlCount,
          pdf: inventory.pdfCount,
        }}
        />
        <Table
          columns={columns}
          dataSource={pages}
          loading={shellLoading || Boolean(scope && !inventory)}
          pagination={{ pageSize: 25 }}
          resizable={false}
          scroll={TABLE_SCROLL}
        />
      </Page.Content>
      <PageEvidenceModal page={selectedPage} onClose={() => setSelectedPage(null)} />
    </ReviewPage>
  );
};

export default Pages;
